import {BaseRequests} from "../BaseRequests";

export const getDataByReportType = ({countEntity, reportType, entityId, type, strategyId, portfId, projId, policyId, year}, api) => {
  const url = BaseRequests.getUrlSearch(`/factdata/${countEntity}/0/report`,{
    [`${type}Id`]:entityId,
    years: year === 'Не указан' ? [null] : [year],
    type: reportType,
    projId,
    portfId,
    policyId,
    strategyId,
  });
  return api.get(url);
}
